import { useState } from "react";
import { Outlet } from "react-router-dom";
import DashboardNavigation from "../../components/dashboard-navigation/dashboard-navigation.component";
import "./dashboard.styles.css";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";

const Dashboard = () => {
  const [isOpen, setIsOpen] = useState(false); // مدیریت وضعیت باز/بسته بودن

  const toggleNavigation = () => {
    setIsOpen((prevState) => !prevState); // تغییر وضعیت باز/بسته بودن
  };

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-content">
        <button
          className="dashboard-open-button"
          onClick={toggleNavigation} // تغییر وضعیت هنگام کلیک
        >
          <MdOutlineKeyboardDoubleArrowRight className="dashboard-open-button-icon" />
        </button>
        {/* ارسال وضعیت و تابع تغییر به DashboardNavigation */}
        <DashboardNavigation isOpen={isOpen} toggleNavigation={toggleNavigation} />
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
